module.exports = __webpack_public_path__ + "img/logo.dfd8cbcc.png";